import { render, staticRenderFns } from "./vodPoint.vue?vue&type=template&id=57d30520&scoped=true"
import script from "./vodPoint.vue?vue&type=script&lang=js"
export * from "./vodPoint.vue?vue&type=script&lang=js"
import style0 from "./vodPoint.vue?vue&type=style&index=0&id=57d30520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d30520",
  null
  
)

export default component.exports